/**
 * Converts navigatorLanguage to the convenient format for APIs
 * @param navigatorLanguage the lang (as translate service format) to convert to the API format for locale parameter
 */
 export function getLocaleConverted(navigatorLanguage: string): string {
    if (navigatorLanguage) {
        navigatorLanguage = navigatorLanguage.split('-')[0];
    }
    switch (navigatorLanguage) {
        case 'fr':
            return 'fr_FR';
        case 'en':
        default:
            return 'en_GB';
    }
}
